import { Component } from '@angular/core';
import { ListService } from '@fry/lib/list';
import { BookingItemsSearch } from '@fry/booking/lib/booking-items';


@Component({
    selector: 'eas-booking-items',
    templateUrl: './booking-items.component.html',
    providers: [
        ListService,
        BookingItemsSearch,
    ],
    standalone: false
})
export class BookingItemsComponent {

  constructor(
  ) { }

}
